
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/creator/ai-recommendation-guide",
      function () {
        return require("private-next-pages/about/creator/ai-recommendation-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/creator/ai-recommendation-guide"])
      });
    }
  